import { createSelector } from 'reselect';

const messagesSelect = (state) => state.messages;

export const selectMessageCounter = createSelector(
  messagesSelect,
  ({ messageCounter }) => messageCounter,
);
